import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { Card, CardHeader, Grid } from '@gogame/components';
import captureError from './captureError';

export const RouterErrorBoundary = () => {
  let error = useRouteError();

  useEffect(() => {
    console.log('[SENTRY] RouterErrorBoundary', { error });
    captureError(error, {cause: 'Router error'});
  }, [captureError, error]);

  return (
    <Grid
      container
      justifyContent={'center'}
      alignContent={'center'}
      fullHeight
    >
      <Grid
        item
        container
        direction={'column'}
        spacing={2}
        style={{ width: '60vw' }}
        data-cy={'routerCatchTypeError'}
      >
        <Card>
          <CardHeader
            title={ `RouterErrorBoundary: Router catch ${error.name}: ${error.message}`}
            titleTypographyProps={{ variant: 'subtitle2', color: 'error' }}
          />
        </Card>
      </Grid>
    </Grid>
  );
};
